module.exports = __webpack_public_path__ + "img/Meow.5a63e0b8.png";